// extracted by mini-css-extract-plugin
module.exports = {"link":"FooterLink_link__LhUFJ"};